import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { AdminService } from '../../../../services/admin.service';
import { UserService } from '../../../../services/user.service';

@Component({
  selector: 'app-get-clothe',
  templateUrl: './get-clothe.component.html',
  styleUrls: ['./get-clothe.component.css']
})

export class GetClotheComponent implements OnInit { 

  public id: string;  
  private value: number = null;

  public disabledBtn = false; 
  public successInfo = false;
  public errorInfo = false;

  constructor(public activeModal: NgbActiveModal,
    private userService: UserService) {
  }

  ngOnInit() {
  }

  setId(id) {
    this.id = id;
  }

  setValue(value) {
    this.value = value;
  }

  renameGroup() {
    this.disabledBtn = true;
    this.successInfo = false;
    this.errorInfo = false;

      this.userService.getClothesPf(this.id , String(this.value)).subscribe(
        (res: any) => {
            this.successInfo = true;
            this.errorInfo = false;
            this.disabledBtn = false;
            this.activeModal.close('ok');
        },
        () => {
          this.errorInfo = true;
        }
      );
  }

  disableBtnValidation() {
    return this.value === null;
  }
 
}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/content-page/views/view-user-profile/get-clothe/get-clothe.component.ts